import { Expose } from 'class-transformer';

export default class AdminJobEmploymentCancelError {
    cancel_reason: string[] = []
    should_cancel_job: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}